if ($('#app-day-part-select').length) {
    var input_day_parts;
    var input_day_part_type;
    var dayPartInputSelecting = false;

    var dayPartInputInit = function(start_time, end_time, type){
        input_day_part_type = type;
        $.ajax({
            type: "GET",
            url: '/dayparts/list',
            dataType: 'json',
            success: function (data) {
                input_day_parts = collect(data['data']);

                var dp_input_start = $('#form_day_part_start');
                var dp_input_end = $('#form_day_part_end');
                var dp_input_dows = $('#form_day_part_dows');
                var dp_input_day_part = $('#form_day_part_day_part');

                dp_input_start.timepicker({
                    showInputs: false,
                    defaultTime: moment(start_time, "HH:mm").format('h:mm A')
                }).on('changeTime.timepicker', function(e) {
                    dayPartInputInputsChange();
                });

                dp_input_end.timepicker({
                    showInputs: false,
                    defaultTime: moment(end_time, "HH:mm").format('h:mm A')
                }).on('changeTime.timepicker', function(e) {
                    dayPartInputInputsChange();
                });

                dp_input_dows.find('button').bind('click', function(index, value){
                    if ($(this).hasClass('btn-default')) {
                        $(this).removeClass('btn-default').addClass('btn-primary');
                    } else {
                        $(this).addClass('btn-default').removeClass('btn-primary');
                    }

                    dayPartInputSetDaysInput(dp_input_dows);

                    dayPartInputInputsChange();
                });

                dp_input_day_part.append('<option value=""></option>');
                dp_input_day_part.append('<optgroup label="Standard">');
                input_day_parts.where('type', '==', input_day_part_type).where('agency_id', '==', 0).each(function(item){
                    dp_input_day_part.append('<option value="' + item['slug'] + '">' + item['name'] + '</option>');
                });
                dp_input_day_part.append('</optgroup>');

                if(input_day_parts.where('type', '==', input_day_part_type).where('agency_id', '!=', 0).count() > 0){
                    dp_input_day_part.append('<optgroup label="Custom">');

                    input_day_parts.where('type', '==', input_day_part_type).where('agency_id', '!=', 0).each(function(item){
                        dp_input_day_part.append('<option value="' + item['slug'] + '">' + item['name'] + '</option>');
                    });

                    dp_input_day_part.append('</optgroup>');
                }

                dp_input_day_part.select2({
                    placeholder: "Choose a daypart...",
                    minimumResultsForSearch: 10
                });
                //$(".select2-selection.select2-selection--multiple:not(:has(i.fa.fa-search.search-icon-input))").prepend("<i class='fa fa-search search-icon-input'></i>")

                dp_input_day_part.on('select2:selecting', function (evt) {
                    dayPartInputSelecting = true
                });

                dp_input_day_part.on('select2:select', function (evt) {
                    if($(evt.target).val() !== ""){
                        dp_values = input_day_parts.where('slug', $(evt.target).val()).first();

                        item_start = moment(dp_values['start'], "HH:mm:ss");
                        item_end = moment(dp_values['end'], "HH:mm:ss");

                        dp_input_start.timepicker('setTime', item_start.format('h:mm A'));
                        dp_input_end.timepicker('setTime', item_end.format('h:mm A'));
                        console.log("test daypart ----- reports");
                        console.log(item_end);
                        console.log(dp_input_end);

                        if(dp_values['m'] === 1){
                            dp_input_dows.find('button[data-value="M"]').removeClass('btn-default').addClass('btn-primary');
                        }else{
                            dp_input_dows.find('button[data-value="M"]').addClass('btn-default').removeClass('btn-primary');
                        }
                        if(dp_values['t'] === 1){
                            dp_input_dows.find('button[data-value="T"]').removeClass('btn-default').addClass('btn-primary');
                        }else{
                            dp_input_dows.find('button[data-value="T"]').addClass('btn-default').removeClass('btn-primary');
                        }
                        if(dp_values['w'] === 1){
                            dp_input_dows.find('button[data-value="W"]').removeClass('btn-default').addClass('btn-primary');
                        }else{
                            dp_input_dows.find('button[data-value="W"]').addClass('btn-default').removeClass('btn-primary');
                        }
                        if(dp_values['r'] === 1){
                            dp_input_dows.find('button[data-value="R"]').removeClass('btn-default').addClass('btn-primary');
                        }else{
                            dp_input_dows.find('button[data-value="R"]').addClass('btn-default').removeClass('btn-primary');
                        }
                        if(dp_values['f'] === 1){
                            dp_input_dows.find('button[data-value="F"]').removeClass('btn-default').addClass('btn-primary');
                        }else{
                            dp_input_dows.find('button[data-value="F"]').addClass('btn-default').removeClass('btn-primary');
                        }
                        if(dp_values['s'] === 1){
                            dp_input_dows.find('button[data-value="S"]').removeClass('btn-default').addClass('btn-primary');
                        }else{
                            dp_input_dows.find('button[data-value="S"]').addClass('btn-default').removeClass('btn-primary');
                        }
                        if(dp_values['u'] === 1){
                            dp_input_dows.find('button[data-value="U"]').removeClass('btn-default').addClass('btn-primary');
                        }else{
                            dp_input_dows.find('button[data-value="U"]').addClass('btn-default').removeClass('btn-primary');
                        }

                        dayPartInputSetDaysInput(dp_input_dows);

                        dayPartInputSelecting = false;
                    }

                });
            }
        });
    };

    var dayPartInputSetDaysInput = function(container){
        var buttons = container.find('button');
        var html = '';

        $.each(buttons, function (index, value) {
            if ($(value).hasClass('btn-primary')) {
                $(value).html($(value).attr('data-value'));
                html += $(value).attr('data-value');
            } else {
                $(value).html('-');
                html += '-';
            }
        });

        container.find('input').val(html);
    };

    var dayPartInputInputsChange = function(){
        if(! dayPartInputSelecting){
            var dp_input_start = $('#form_day_part_start');
            var dp_input_end = $('#form_day_part_end');
            var dp_input_day_part = $('#form_day_part_day_part');

            dp_start = moment(dp_input_start.val(), 'h:mm A');
            dp_end = moment(dp_input_end.val(), 'h:mm A');
            var dp_dows = $('#form_day_part_days').val();

            var dp_match = false;
            input_day_parts.each(function(item){
                pass = true;

                if((dp_dows[0] === '-') && (item['m'] === 1)){
                    pass = false;
                }
                if((dp_dows[1] === '-') && (item['t'] === 1)){
                    pass = false;
                }
                if((dp_dows[2] === '-') && (item['w'] === 1)){
                    pass = false;
                }
                if((dp_dows[3] === '-') && (item['r'] === 1)){
                    pass = false;
                }
                if((dp_dows[4] === '-') && (item['f'] === 1)){
                    pass = false;
                }
                if((dp_dows[5] === '-') && (item['s'] === 1)){
                    pass = false;
                }
                if((dp_dows[6] === '-') && (item['u'] === 1)){
                    pass = false;
                }

                item_start = moment(item['start'], "HH:mm:ss");
                item_end = moment(item['end'], "HH:mm:ss");

                if((! item_start.isSame(dp_start)) || (! item_end.isSame(dp_end))){
                    pass = false;
                }

                if(pass){
                    dp_match = item;
                }
            });

            if(dp_match !== false){
                dp_input_day_part.val(dp_match['slug']).trigger("change");
            }else{
                console.log("MATCH: " + dp_match);
                dp_input_day_part.val("").trigger("change");
            }
        }
    };
}


var ratingsHumanDaypart = function(day_part){
    dp_start = day_part.substring(7, 11);
    dp_end = day_part.substring(11, 15);

    dp_start = moment(dp_start, 'HHmm');
    dp_end = moment(dp_end, 'HHmm');

    return day_part.substring(0, 7) + ' ' + dp_start.format('h:mm A') + ' to ' + dp_end.format('h:mm A');
};